import { render, staticRenderFns } from "./TransferTab.vue?vue&type=template&id=379c9a98"
import script from "./TransferTab.vue?vue&type=script&lang=js"
export * from "./TransferTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports